<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Kds Routing Flow {{ (kds_routing_flow.route_code) ? (" - " + kds_routing_flow.route_code) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Kds Routing Flow - {{kds_routing_flow.route_code}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Kds Routing Flow - {{kds_routing_flow.route_code}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="kds_routing_flow.route_code" :disabled="viewMode" slot-scope="" input-classes="form-control" />
                    <a-select 
                    mode="multiple" 
                    v-model="kds_routing_flow.station_ids" 
                    showSearch 
                    placeholder="Select Station Id" 
                    style="width: 100%" 
                    :filterOption="filterOption" 
                    @change="handleSelectionChange"
                    :disabled="viewMode"
                    >
                        <a-select-option 
                            v-for="station in stationList" 
                            :key="station.id" 
                            :value="station.id"
                        >
                            {{ station.station_name }}
                        </a-select-option>
                    </a-select>

                    <!-- Draggable List -->
                    <p style="text-indent: 5px; font-size: 11px; margin-top: 20px;">Arrange station here:</p>
                    <draggable 
                    v-model="selectedStations" 
                    class="list-group mt-0" 
                    @end="updateStationIds"
                    >
                    <div 
                        v-for="(station, index) in selectedStations" 
                        :key="station.id" 
                        class="list-item"
                    >
                        {{ station.station_name }}
                        <span @click="removeStation(index)" class="remove-btn">❌</span>
                    </div>
                    </draggable>

                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="remark" :disabled="viewMode"/>
                </base-input>
            </div>


            <br><br>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>

                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'
    import draggable from 'vuedraggable'

    var component_x;
    export default {
        components: {
            DynamicForm,
            draggable
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Kitchen Routing Flow?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

            component_x = this

            const kds_station_data = await HTTPRequest.getRequest(this.endPoint + 'kds_stations/get_valid_kds_stations', null, null)
            component_x.stationList = kds_station_data

            if (component_x.profileId > 0) {
                var kds_routing_flow_data = await HTTPRequest.getRequest(component_x.endPoint + 'kds_routing_flows/' + component_x.profileId, null)
                if (kds_routing_flow_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (kds_routing_flow_data["error"] == undefined) {
                        component_x.kds_routing_flow = kds_routing_flow_data
                        component_x.remark = kds_routing_flow_data["remark"]
                    } else {
                        this.errors = kds_routing_flow_data["error"].split(",")
                    }
                }
            }

            // To handle update on dynamic forms on load
            // this.dynamicFormKey++;
        },
        data: function () {
            return {
                errors: [],
                remark: '',
                customFormMode: 1,
                customForm: {},
                profileData: {},
                kds_routing_flow: {},
                formErrors: [],
                viewMode: this.$attrs.viewMode,
                fetching: false,
                lastFetchId: 0,
                stationList: [],
                selectedStations: [], 
                dragging: false,
            }
        },
        methods: {
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Route Code', this.kds_routing_flow.route_code));
                this.errors.push(ValidateField.required('Station Id', this.kds_routing_flow.station_ids));
                this.errors.push(ValidateField.charMinAndMax('Route Code', this.kds_routing_flow.route_code, 0, 30));
                this.errors = this._.compact(this.errors);
                // document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    this.kds_routing_flow.route_code = this.kds_routing_flow.route_code.trim()
                    this.kds_routing_flow.remark = this.remark.trim()
                    this.kds_routing_flow.status = 'A'
                    var kdsRoutingFlowPayload = { kds_routing_flow: this.kds_routing_flow }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'kds_routing_flows', null, kdsRoutingFlowPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    this.kds_routing_flow.route_code = this.kds_routing_flow.route_code.trim()
                    this.kds_routing_flow.remark = this.remark.trim()
                    let status = (this.kds_routing_flow.status == null) ?  "A" : this.kds_routing_flow.status
                    this.kds_routing_flow.status = status
                    var kdsRoutingFlowPayload = { kds_routing_flow: this.kds_routing_flow }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'kds_routing_flows/' + this.profileId, null, kdsRoutingFlowPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            },
             handleStationSearch (value) {
                this.fetching = true
                this.lastFetchId += 1;
                const fetchId = this.lastFetchId;

                fetch(this.endPoint + `kds_stations?name=${value}`, {
                    headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + secureStorage.getItem("accessToken"), 
                    "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
                    }
                })
                .then(res => res.json())
                .then(res => {
                    if (fetchId !== this.lastFetchId) {
                        // for fetch callback order
                        return;
                    }
                    
                    this.stationList = res.data.map(value => {
                        return {
                            id: value.id,
                            station_name: value.station_name,
                            disabled: false 
                        }
                    })

                    // this.payment_types.unshift({id: 0, name: ' All Payment Types'})
                    this.fetching = false
                })
            },
            getSelectedStationId(value){
                this.kds_routing_flow.station_ids = value;
            },

            handleSelectionChange(value){
                this.selectedStations = value.map(id => this.stationList.find(station => station.id === id));

            },
            updateStationIds() {
                this.kds_routing_flow.station_ids = this.selectedStations.map(station => station.id);
            },
            removeStation(index) {
                const removedStation = this.selectedStations[index];
                this.selectedStations.splice(index, 1);
                this.kds_routing_flow.station_ids = this.kds_routing_flow.station_ids.filter(id => id !== removedStation.id);
            },
        }
    }
</script>

<style scoped>
    .list-group {
    margin-top: 10px;
    border: 1px solid #ddd;
    padding: 10px;
    background: #f9f9f9;
    }
    .list-item {
    padding: 5px;
    margin: 5px 0;
    background: #fff;
    border: 1px solid #ddd;
    cursor: grab;
    display: flex;
    justify-content: space-between;
    }
    .remove-btn {
    cursor: pointer;
    color: red;
    }
</style>